import Vue from 'vue'
import Router from 'vue-router'

import authAPI from '@/api/auth'
import store from '@/vuex/store'

Vue.use(Router)

const notFound = resolve => require(['components/notFound.vue'], resolve)
const forbidden = resolve => require(['components/forbidden.vue'], resolve)
const underConstruction = resolve => require(['components/underConstruction.vue'], resolve)
const resetPassword = resolve => require(['components/resetPassword.vue'], resolve)
const activeAccount = resolve => require(['components/activeAccount.vue'], resolve)
const registerSucceeded = resolve => require(['components/registerSucceeded.vue'], resolve)

const Privacy = resolve => require(['components/privacy.vue'], resolve)
const contactUs = resolve => require(['components/contactUs.vue'], resolve)
const aboutUs = resolve => require(['components/aboutUs.vue'], resolve)

const internsList = resolve => require(['components/interns/list.vue'], resolve)
const internsEntry = resolve => require(['components/interns/entry.vue'], resolve)
const companyList = resolve => require(['components/interns/company/list.vue'], resolve)
const companyEntry = resolve => require(['components/interns/company/entry.vue'], resolve)
const companyPhoto = resolve => require(['components/interns/company/photo.vue'], resolve)

const company = resolve => require(['components/company.vue'], resolve)
const companySignup = resolve => require(['components/company/signup.vue'], resolve)
const companySettings = resolve => require(['components/company/settings.vue'], resolve)

const companyRegister = resolve => require(['components/company/register.vue'], resolve)
const companyRegisterSucceeded = resolve => require(['components/company/registerSucceeded.vue'], resolve)

const companyCreate = resolve => require(['components/company/create.vue'], resolve)
const companyCareerList = resolve => require(['components/company/careerList.vue'], resolve)
const companyCareerCreate = resolve => require(['components/company/careerCreate.vue'], resolve)
const companyResumeList = resolve => require(['components/company/resumeList.vue'], resolve)
const companyRecruitedResume = resolve => require(['components/company/resumeList/entry.vue'], resolve)

const user = resolve => require(['components/user.vue'], resolve)
const signup = resolve => require(['components/user/signup.vue'], resolve)

const userSettings = resolve => require(['components/user/settings.vue'], resolve)
const userProfiles = resolve => require(['components/user/profiles.vue'], resolve)
const userInternsView = resolve => require(['components/user/internsView.vue'], resolve)
const userInternsSave = resolve => require(['components/user/interns/save/internsSave.vue'], resolve)

const userInternsHistory = resolve => require(['components/user/interns/history/internsHistory.vue'], resolve)

const userResumeView = resolve => require(['components/user/resumeView.vue'], resolve)
const userResumeCreate = resolve => require(['components/user/resumes/create/resumeCreate.vue'], resolve)
const userResumeEntry = resolve => require(['components/user/resumes/entry/resumeEntry.vue'], resolve)
const userResumeList = resolve => require(['components/user/resumes/list/resumeList.vue'], resolve)
const userResumeHistory = resolve => require(['components/user/resumes/history/resumeHistory.vue'], resolve)

const commonMeta = {
  noContainer: true,
  displayMainHeader: true,
  displayDebutHeader: false,
  displayCompanyHeader: false,
  displayFooter: true
}

const debutMeta = Object.assign({}, commonMeta, {
  noContainer: true,
  displayMainHeader: true,
  displayDebutHeader: true,
  displayCompanyHeader: false,
  displayFooter: true,
  userType: 'users'
})

const companyMeta = Object.assign({}, commonMeta, {
  noContainer: true,
  displayMainHeader: true,
  displayDebutHeader: false,
  displayCompanyHeader: true,
  displayFooter: true,
  userType: 'manipulator'
})

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-actived',
  scrollBehavior: (to, from, savedPosition) => {
    let newUserBg = document.querySelector('.intern__new-user-bg')
    let pathDontScrollToTop = ['homepage', 'internsList', 'companyList']
    let dontscroll = false
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { selector: to.hash }
    } else {
      if ((to.name === from.name) || pathDontScrollToTop.indexOf(to.name) > -1) {
        if (typeof from.query !== 'undefined' && typeof to.query !== 'undefined') {
          ['salary_range', 'salary', 'city'].forEach((f) => {
            if (typeof from.query[f] === 'undefined' && typeof to.query[f] !== 'undefined') {
              dontscroll = true
            } else {
              if (typeof from.query[f] !== 'undefined' && typeof to.query[f] !== 'undefined') {
                if (from.query[f] !== to.query[f]) {
                  dontscroll = true
                }
              }
            }
          })
        }
      }
      if (dontscroll === false) {
        if (newUserBg) {
          if (typeof newUserBg.offsetHeight !== 'undefined') {
            return { x: 0, y: newUserBg.offsetHeight - 84 }
          }
        }
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/:locale(tw|en)?/employers',
      component: company,
      meta: { ...companyMeta },
      props: true,
      children: [
        {
          path: 'signup',
          name: 'companySignup',
          component: companySignup,
          meta: { auth: false, ...companyMeta },
          props: true
        },
        {
          path: 'register', // 建立廠商資訊
          name: 'companyRegister',
          component: companyRegister,
          meta: { auth: false, ...companyMeta },
          props: true
        },
        {
          path: 'hello', // 建立廠商資訊
          name: 'companyRegisterSucceeded',
          component: companyRegisterSucceeded,
          meta: { auth: false, ...companyMeta },
          props: true
        },
        {
          path: 'settings',
          name: 'companySettings',
          component: companySettings,
          meta: { auth: true, ...companyMeta },
          props: true
        },
        {
          path: ':alias?/profile', // 建立公司資訊
          name: 'companyProfile',
          component: companyCreate,
          beforeEnter: (to, from, next) => {
            const token = store.getters['manipulators/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isCompanyAuthTouchExpired']) {
                store.dispatch('utilities/setCompanyAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'companySignup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          meta: { auth: true, ...companyMeta },
          props: true
        },
        {
          path: ':alias?/career/list', // 管理職缺
          name: 'companyCareerList',
          component: companyCareerList,
          beforeEnter: (to, from, next) => {
            const token = store.getters['manipulators/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isCompanyAuthTouchExpired']) {
                store.dispatch('utilities/setCompanyAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'companySignup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          meta: { auth: true, ...companyMeta },
          props: true
        },
        {
          path: ':alias?/career/create', // 創建職缺
          name: 'companyCareerCreate',
          component: companyCareerCreate,
          beforeEnter: (to, from, next) => {
            const token = store.getters['manipulators/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isCompanyAuthTouchExpired']) {
                store.dispatch('utilities/setCompanyAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'companySignup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          meta: { auth: true, ...companyMeta },
          props: true
        },
        {
          path: ':alias?/career/:vacancyId/edit', // 編輯職缺
          name: 'companyCareerEdit',
          component: companyCareerCreate,
          beforeEnter: (to, from, next) => {
            const token = store.getters['manipulators/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isCompanyAuthTouchExpired']) {
                store.dispatch('utilities/setCompanyAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'companySignup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          meta: { auth: true, ...companyMeta },
          props: true
        },
        {
          path: ':alias?/resume/list', // 我收過的履歷
          name: 'companyResumeList',
          component: companyResumeList,
          beforeEnter: (to, from, next) => {
            const token = store.getters['manipulators/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isCompanyAuthTouchExpired']) {
                store.dispatch('utilities/setCompanyAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'companySignup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          meta: { auth: true, ...companyMeta },
          props: true
        },
        {
          path: ':alias?/resume/:id', // 我收過的履歷內頁
          name: 'companyRecruitedResume',
          component: companyRecruitedResume,
          beforeEnter: (to, from, next) => {
            const token = store.getters['manipulators/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isCompanyAuthTouchExpired']) {
                store.dispatch('utilities/setCompanyAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'companySignup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          meta: { auth: true, ...companyMeta },
          props: true
        }
      ]
    },
    {
      path: '/:locale(tw|en)?/user', // 帳號設定(user)
      name: 'user',
      component: user,
      beforeEnter: (to, from, next) => {
        const token = store.getters['users/getToken']
        if (typeof token !== 'undefined' &&
          token !== ''
        ) {
          if (store.getters['utilities/isUserAuthTouchExpired']) {
            store.dispatch('utilities/setUserAuthTouchTimestamp')
            authAPI.touch(token)
              .then(() => {
                next()
              }, () => {
                next({
                  name: 'signup'
                })
              })
          } else {
            next()
          }
        }
      },
      meta: { auth: true, ...debutMeta },
      props: true,
      children: [
        {
          path: 'settings', // 帳號設定(user)
          name: 'userSettings',
          component: userSettings,
          meta: { auth: true, ...debutMeta },
          props: true
        },
        {
          path: 'profiles', // 個人資料設定
          name: 'userProfiles',
          component: userProfiles,
          meta: { auth: true, ...debutMeta },
          props: true
        },
        {
          path: 'jobs',
          component: userInternsView,
          redirect: '/:locale(tw|en)?/user/jobs/save',
          children: [
            {
              path: 'history', // 瀏覽過的職缺
              name: 'userInternsHistory',
              component: userInternsHistory,
              meta: { auth: true, ...debutMeta },
              props: true
            },
            {
              path: 'save', // 收藏的職缺
              name: 'userInternsSave',
              component: userInternsSave,
              meta: { auth: true, ...debutMeta },
              props: true
            }
          ]
        },
        {
          path: 'interns',
          redirect: '/:locale(tw|en)?/user/jobs/save',
          children: [
            {
              path: 'history',
              redirect: '/:locale(tw|en)?/user/jobs/history'
            },
            {
              path: 'save',
              redirect: '/:locale(tw|en)?/user/jobs/save'
            }
          ]
        },
        {
          path: 'resume',
          component: userResumeView,
          redirect: '/:locale(tw|en)?/user/resume/list',
          beforeEnter: (to, from, next) => {
            const token = store.getters['users/getToken']
            if (typeof token !== 'undefined' &&
              token !== ''
            ) {
              if (store.getters['utilities/isUserAuthTouchExpired']) {
                store.dispatch('utilities/setUserAuthTouchTimestamp')
                authAPI.touch(token)
                  .then(() => {
                    next()
                  }, () => {
                    next({
                      name: 'signup'
                    })
                  })
              } else {
                next()
              }
            }
          },
          props: true,
          children: [
            {
              path: 'create', // 建立履歷
              name: 'userResumeCreate',
              component: userResumeCreate,
              meta: { auth: true, ...debutMeta },
              props: true
            },
            {
              path: 'history', // 我的應徵紀錄
              name: 'userResumeHistory',
              component: userResumeHistory,
              meta: { auth: true, ...debutMeta },
              props: true
            },
            {
              path: 'list', // 履歷列表
              name: 'userResumeList',
              component: userResumeList,
              meta: { auth: true, ...debutMeta },
              props: true
            },
            {
              path: ':id', // 我的履歷內頁
              name: 'userResumeEntry',
              component: userResumeEntry,
              meta: { auth: true, ...debutMeta },
              props: true
            },
            {
              path: ':id/edit', // 編輯履歷
              name: 'userResumeEdit',
              component: userResumeCreate,
              meta: { auth: true, ...debutMeta },
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '/:locale(tw|en)?/jobs',
      name: 'internsList',
      component: internsList,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/jobs/:alias',
      name: 'internsEntry',
      component: internsEntry,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/companies',
      name: 'companyList',
      component: companyList,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/companies/:alias',
      name: 'companyEntry',
      component: companyEntry,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/companies/:alias/photo',
      name: 'companyPhoto',
      component: companyPhoto,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/reset-password/:id/:checkSum',
      name: 'resetPassword',
      component: resetPassword,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/active-account/:id/:checkSum',
      name: 'activeAccount',
      component: activeAccount,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/hello',
      name: 'registerSucceeded',
      component: registerSucceeded,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/signup',
      name: 'signup',
      component: signup,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/signin',
      redirect: '/:locale(tw|en)?/signup'
    },
    {
      path: '/:locale(tw|en)?/403',
      name: 'forbidden',
      component: forbidden,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/comingsoon',
      name: 'underConstruction',
      component: underConstruction,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/404',
      name: 'notFound',
      component: notFound,
      meta: { auth: false, ...commonMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/privacy',
      name: 'privacy',
      component: Privacy,
      meta: { auth: false, ...debutMeta, ...{ noContainer: false } },
      props: true
    },
    {
      path: '/:locale(tw|en)?/contact',
      name: 'contactUs',
      component: contactUs,
      meta: { auth: false, ...debutMeta, ...{ noContainer: false } },
      props: true
    },
    {
      path: '/:locale(tw|en)?/aboutus',
      name: 'aboutUs',
      component: aboutUs,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?',
      name: 'homepage',
      component: internsList,
      meta: { auth: false, ...debutMeta },
      props: true
    },
    {
      path: '/:locale(tw|en)?/interns',
      children: [
        {
          path: 'companies',
          redirect: '/:locale(tw|en)?/companies'
        },
        {
          path: 'companies/:alias',
          redirect: '/:locale(tw|en)?/companies/:alias'
        },
        {
          path: 'companies/:alias/photo',
          redirect: '/:locale(tw|en)?/companies/:alias/photo'
        },
        {
          path: ':alias',
          redirect: '/:locale(tw|en)?/jobs/:alias'
        },
        {
          path: '',
          redirect: '/:locale(tw|en)?/jobs'
        }
      ]
    },
    {
      path: '/:locale(tw|en)?/interns/companies',
      redirect: '/:locale(tw|en)?/companies'
    },
    {
      path: '/:locale(tw|en)?/company',
      redirect: '/:locale(tw|en)?/employers',
      children: [
        {
          path: 'signup',
          redirect: '/:locale(tw|en)?/employers/signup'
        },
        {
          path: 'register',
          redirect: '/:locale(tw|en)?/employers/register'
        },
        {
          path: 'settings',
          redirect: '/:locale(tw|en)?/employers/settings'
        },
        {
          path: ':alias?/profile',
          redirect: '/:locale(tw|en)?/employers/:alias?/profile'
        },
        {
          path: ':alias?/career/list',
          redirect: '/:locale(tw|en)?/employers/:alias?/career/list'
        },
        {
          path: ':alias?/career/create',
          redirect: '/:locale(tw|en)?/employers/:alias?/career/create'
        },
        {
          path: ':alias?/career/:vacancyId/edit',
          redirect: '/:locale(tw|en)?/employers/:alias?/career/:vacancyId/edit'
        },
        {
          path: ':alias?/resume/list',
          redirect: '/:locale(tw|en)?/employers/:alias?/resume/list'
        },
        {
          path: ':alias?/resume/:id',
          redirect: '/:locale(tw|en)?/employers/:alias?/resmue/:id'
        }
      ]
    },
    {
      path: '*',
      component: notFound,
      meta: { auth: false, ...commonMeta }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js